export default "__VITE_ASSET__BeIwSgOv__"